import Logo from 'layouts/logo/logo';
// @ts-ignore
import LogoImage from 'assets/images/logo.svg';
import PrivacyPolicyContent from 'components/legal/privacy-policy-content';
import {
  PrivacyShell,
  PrivacyInner,
  PrivacyLogoWrap,
  PrivacyPage as PrivacyDocument
} from 'components/legal/privacy-document.style';

const PrivacyPage = () => (
  <PrivacyShell>
    <PrivacyInner>
      <PrivacyLogoWrap>
        <Logo text="Wallet" imageUrl={LogoImage} />
      </PrivacyLogoWrap>
      <PrivacyDocument>
        <PrivacyPolicyContent />
      </PrivacyDocument>
    </PrivacyInner>
  </PrivacyShell>
);

export default PrivacyPage;
